const BRANDS: Record<number, string> = {
	1: 'Luminultra',
	2: 'Accucount',
	3: 'Lumikem',
	4: 'Hach China',
	6: 'Biohealth' 
}

const ORG_NAME_TO_BRANDS: Record<string, string> = {
	"LuminUltra": "Luminultra",
	"Nalco Champion": "Accucount",
	"ChampionX": "Accucount",
	"Kemira": "Lumikem",
	"Hach China": "Hach China",
	"Veolia": "Biohealth"
}

export { BRANDS, ORG_NAME_TO_BRANDS };